module.exports = __webpack_public_path__ + "static/media/restore-24px.dfc0d4fb.svg";